@import '~style-sheet-helpers/core.less';
@import './shared-classes.module.less';
@import '../../app-brand/entities/entity-layer.module.less';
@import '../../constants/screen-width-breakpoints.module.less';
@import (reference) '../../constants/spacing.module.less';

@headerHeight: 48px;

@linkStates: {
  &:hover:focus,
  &:hover {
    color: @top-nav--button--hover--text-color;
    background: @top-nav--button--hover--background-color;
    text-decoration: none;
  }

  &:active:hover,
  &:active,
  &.active,
  &.active:hover,
  &:has(a.active) {
    color: @top-nav--button--active--text-color;
    background: @top-nav--background-color-active;
    .menu-item-icon {
      color: @top-nav--button--active--text-color;
      svg {
        color: @top-nav--button--active--text-color;
      }
    }
  }
};

.beta-link-wrapper {
  display: flex;
  margin: 0 @space-8;
  white-space: nowrap;
}

.menu-item-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 100%;
  flex-shrink: 0;
}

.menu-item {
  min-width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;
  border-radius: @space-4;
  margin: @space-8 @space-4;
  height: 32px;

  @linkStates();
  .menu-item-icon {
    height: 18px;
    color: @top-nav--button--text-color;
    svg {
      height: 18px;
      color: @top-nav--button--text-color;
    }

    &:hover {
      svg {
        fill: @top-nav--button--hover--fill-color;
      }
    }
  }

  a {
    min-width: 100%;
    height: 100%;
  }

  .settings-link {
    min-width: 100%;
    height: 100%;
  }

  &:hover {
    background: @top-nav--button--hover--background-color;
  }

  :global(.dropdown-toggler) + div {
    top: 100%;
  }

  button {
    width: 100%;
    cursor: pointer;
  }

  &.anchored {
    background-color: @app-header--menu-item-anchored--background-color;
  }

  .icon-wrapper {
    min-width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &:last-child {
    margin-right: 0;
  }
}

.header-banner-wrapper {
  position: relative;
  left: 0;
  right: 0;
  width: 100vw;
}

.app-header {
  position: relative;
  height: @headerHeight;
  width: 100vw;
  background: @top-nav--background-color;
  display: flex;
  align-items: center;
  flex-direction: row;
  padding: 0 @space-24;

  @media @mobile, @ultramobile {
    width: 100vw;
    min-height: 40px;
    overflow-y: hidden;
  }
}

.logo {
  display: block;
  height: @headerHeight;
  position: relative;
  flex-shrink: 0;
  padding-right: @space-16;

  a {
    display: flex;
    height: @headerHeight;
    align-items: center;

    &:hover {
      text-decoration: none;
    }

    &:focus {
      background: none;
    }
  }

  img {
    height: 21px;
    margin-right: 8px;
    margin-top: 1px;
  }
}

.routes {
  flex: 1;
  font-size: 0;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: @space-8;
  min-width: 0;

  .app-header-route {
    border: 0;
    padding: @space-8;
    text-decoration: none;
    color: @top-nav--button--text-color;
    font-size: 14px;
    font-weight: @normal;
    border-radius: 4px;
    white-space: nowrap;

    @linkStates();
  }
}

.routes-dropdown-wrapper {
  min-width: 160px;
  border: none;
  border-radius: @space-4;
}

.routes-dropdown {
  display: none;
}

.routes-dropdown-toggler {
  background: transparent;
  border: 1px solid @top-nav--routes-dropdown--border-color;
  color: @top-nav--routes-dropdown--text-color !important;
  text-transform: capitalize;
  width: 156px;

  svg {
    fill: @top-nav--routes-dropdown--text-color;
  }

  &:hover {
    background: @top-nav--routes-dropdown--hover--background-color;
    border: 1px solid @top-nav--routes-dropdown--border-color;
  }
}

.routes-dropdown-item {
  display: block;
  background: @top-nav--routes-dropdown-item--background-color;
  border: none;
  padding: 0;

  &:hover {
    background: @top-nav--routes-dropdown-item--hover--background-color;
    a {
      text-decoration: none;
      color: @top-nav--routes-dropdown-item--hover--text-color;
    }
  }
  &:active {
    background: @top-nav--routes-dropdown-item--active--background-color;
    a {
      color: @top-nav--routes-dropdown-item--active--text-color;
      font-weight: @bold;
    }
  }

  .app-header-route {
    color: @top-nav--routes-dropdown-item--text-color;
    display: block;
    padding: 10px;
    font-size: 14px;
  }
}

.rate-browser-button {
  cursor: pointer;
  width: fit-content;
  color: @top-nav--button--fill-color;
  font-size: 14px;
  padding: @space-8 @space-8;
  border-radius: @space-4;

  > svg {
    transform: scale(0.55);
    fill: @top-nav--button--fill-color;
  }

  &:hover {
    background: @top-nav--button--hover--background-color;

    > svg {
      fill: @top-nav--button--hover--fill-color;
    }
  }
}

.store-status-menu {
  position: relative;
  width: 32px;
}

.print-queue-icon {
  margin-top: 6px;
}

// Dynamic breakpoints based on which optional buttons are visible.
// TODO: This approach creates 2^N combinations of classes for N buttons (currently 4 combinations for 2 buttons).
// Consider a more scalable pattern, such as CSS container queries, a single `.has-N-buttons` approach
// with consistent button widths, or JavaScript-based breakpoint detection. - Greg S 2/4/26
@breakpoint-both-buttons: 1460px;
@breakpoint-v2-only: 1345px;
@breakpoint-shippy-only: 1325px;
@breakpoint-no-buttons: 1215px;

// Mixin for route collapse styles
.collapse-routes() {
  .app-header-route {
    display: none;
  }

  .routes {
    flex: none;
  }

  .routes-dropdown {
    display: flex;
    align-items: center;
    flex: 1;

    button.routes-dropdown-toggler {
      background: @top-nav--routes-dropdown-background-color;
    }
  }
}

// Both buttons visible
.app-header.has-v2-button.has-shippy-button {
  @media screen and (max-width: @breakpoint-both-buttons) {
    .collapse-routes();
  }
}

// Only V2 button visible (no Shippy)
.app-header.has-v2-button:not(.has-shippy-button) {
  @media screen and (max-width: @breakpoint-v2-only) {
    .collapse-routes();
  }
}

// Only Shippy button visible (no V2)
.app-header:not(.has-v2-button).has-shippy-button {
  @media screen and (max-width: @breakpoint-shippy-only) {
    .collapse-routes();
  }
}

// Neither button visible
.app-header:not(.has-v2-button):not(.has-shippy-button) {
  @media screen and (max-width: @breakpoint-no-buttons) {
    .collapse-routes();
  }
}
